import { render, staticRenderFns } from "./GroupCountQC.vue?vue&type=template&id=28015e9c&scoped=true"
import script from "./GroupCountQC.vue?vue&type=script&lang=js"
export * from "./GroupCountQC.vue?vue&type=script&lang=js"
import style0 from "./GroupCountQC.vue?vue&type=style&index=0&id=28015e9c&prod&scoped=true&lang=css"
import style1 from "./GroupCountQC.vue?vue&type=style&index=1&id=28015e9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28015e9c",
  null
  
)

export default component.exports